<template>
  <div class="register-of-payments">
    <div class="container">
      <breadcrumb v-if="!isMobile" crumb="register-of-payments" />

      <RegisterOfPaymentsToolbar
        :show-table-payments-menu="multipleSelection.length > 0"
        :selected-debt="selected_debt"
        @searchPayments="searchPayments"
        @setDialog="setDialogAddPayment"
      />
    </div>

    <div class="register-of-payments__table-container">
      <el-table
        ref="multipleTable"
        v-loading="isLoading"
        :data="tableData"
        style="width: 100%"
        :span-method="arraySpanMethod"
        class="registry-table"
        row-key="id"
        border
        :row-class-name="tableRowClassName"
        default-expand-all
        @select-all="handleSelectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column width="40" type="selection" />

        <template v-for="col in config">
          <el-table-column
            :key="col.field"
            :prop="col.field"
            :min-width="col.width"
            :type="col.type"
            resizable
          >
            <template slot="header">
              <div :class="!!col.subName && 'fs-10'">
                {{ col.name }}
                <div v-if="col.subName">{{ col.subName }}</div>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                :class="[
                  {
                    pointer: col.action,
                    'fs-10': !!scope.row.children,
                    [getClass(scope.row)]: col.field === 'payments_left',
                  },
                ]"
                @click="handleOpenModal(col.action, scope.row)"
              >
                {{ getContentTableCell(col, scope.row) }}
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <div class="debitorka">
      <p v-if="totalDebt > 0">
        Общая сумма дебиторской задолженности - <b>{{ formattedTotalDebt }}</b>
      </p>
      <p v-if="totalDebt == 0">Дебиторская задолженность отсутствует</p>
    </div>

    <div class="container">
      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
    </div>

    <modal-ttn
      v-if="isShowTtnModal"
      :response="response"
      :shortage="shortage"
      :load-date="loadDate"
      :type="bid.type_code"
      :default-ttn-id="currentTtnId"
      @close="setClose('isShowTtnModal')"
      @update="handleUpdate"
    />
    <bids-act-modal
      :act-dialog="isShowActModal"
      :response="response"
      :active-act="activeAct"
      :doc-types="getDocumentTypes"
      :price-per-tonn="bid.expediter_price_per_tonn || 0"
      :loader="isLoading"
      @close="setClose('isShowActModal')"
      @status="id => fetchFlight({ id })"
      @update="handleUpdateAct"
    />
    <register-add-payment
      :items="multipleSelection"
      :visible-modal-name="visibleModalName"
      :selected-debt="selected_debt"
      @updatePayment="handleUpdatePayment"
      @close="setDialogAddPayment(null)"
    />
    <bids-payments-modal
      :payment-dialog="isShowPaymentModal"
      :loading="isLoading"
      :paying-loader="isLoading"
      :payments-list="isLoading"
      :response="response"
      :active-act="activeAct"
      :bid="bid"
      @close="() => setClose('isShowPaymentModal')"
      @update="handleUpdate"
    />
    <el-dialog
      :visible="isShowPassportModal"
      append-to-body
      width="50%"
      @close="setClose('isShowPassportModal')"
    >
      <passport-fill :current-person="response" />
    </el-dialog>

    <el-dialog
      title="Редактирование контрагента"
      :visible="isShowContragentModal"
      width="50%"
      center
      :close-on-click-modal="false"
      @close="setClose('isShowContragentModal')"
    >
      <contragent-edit :contragent="{ inn: innContagent }" />
    </el-dialog>
    <driver-edit
      :edit-driver="driver"
      :close-modal="() => setClose('isShowDriverModal')"
      :dialog-visible="isShowDriverModal"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { singleColums, tableFields } from '@/views/RegisterOfPayments/constants'
import BidsActModal from '@/views/LoadDay/Modals/Act/BidsActModal'
import BidsPaymentsModal from '@/views/LoadDay/Modals/Payments/BidsPaymentsModal'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import ContragentEdit from '@/components/Contragents/ContragentEdit'
import DriverEdit from '@/views/Driver/Driver-edit'
import ModalTtn from '@/components/Modals/ModalTTN'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import PassportFill from '@/components/Forms/PassportFill'
import RegisterAddPayment from '@/views/RegisterOfPayments/modals/RegisterAddPayment'
import RegisterOfPaymentsToolbar from '@/views/RegisterOfPayments/components/RegisterOfPaymentsToolbar'

import { RepositoryFactory } from '@/api/RepositoryFactory'
const totalDebtAPI = RepositoryFactory.get('tableOfPayments')

export default {
  name: 'RegisterOfPayments',
  components: {
    DriverEdit,
    PaginationCustom,
    ContragentEdit,
    RegisterOfPaymentsToolbar,
    PassportFill,
    ModalTtn,
    BidsPaymentsModal,
    BidsActModal,
    Breadcrumb,
    RegisterAddPayment,
  },
  data() {
    return {
      config: tableFields,
      isShowActModal: false,
      isShowTtnModal: false,
      isShowPaymentModal: false,
      isShowPassportModal: false,
      isShowContragentModal: false,
      isShowDriverModal: false,
      innContagent: '',
      currentTtnId: 0,
      page: 1,
      visibleModalName: null,
      multipleSelection: [],
      search: { 'per-page': 5 },
      totalDebt: -1, // общая сумма дебиторки, выводимая под таблицей
    }
  },
  computed: {
    ...mapGetters({
      tableData: 'registerOfPayments/getRegisterData',
      pagination: 'registerOfPayments/getRegisterPagination',
      isLoading: 'registerOfPayments/getLoading',
      response: 'registerOfPayments/getResponse',
      getItems: 'registerOfPayments/getItems',
      // paymentLoading: 'payments/getLoading',
      // payingLoader: 'payments/getLoader',
      // paymentsList: 'payments/getPayments',
    }),
    shortage() {
      const res = {}

      if (this.response && this.response.bid) {
        const { allow_shortage_is_percents, allow_shortage } = this.response.bid

        res.perc = allow_shortage_is_percents
        res.val = allow_shortage || 0
      }

      return res
    },
    loadDate() {
      return this.response && this.response['load-day']
        ? this.response['load-day'].load_date
        : ''
    },
    activeAct() {
      if (!this.response || !this.response.id) {
        return {}
      }
      const acts = this.getItems(this.response.id, 'acts')

      return acts.find(c => c.files.length) || acts[0]
    },
    bid() {
      return this.response?.bid || {}
    },
    driver() {
      return this.response?.driver || {}
    },
    selected_debt() {
      return this.multipleSelection.reduce(
        (sum, item) => sum + item.payments_left,
        0,
      )
    },
    formattedTotalDebt() {
      return Intl.NumberFormat('ru-RU')
        .format(Number(this.totalDebt.toFixed(2)))
        .replace(',', '.')
    },
  },
  created() {
    this.fetchItems()
    this.getTotalDebt()
  },
  methods: {
    ...mapActions('registerOfPayments', [
      'fetchFlight',
      'fetchRegisterData',
      'fetchRegisterItem',
      'fetchFlightsActs',
    ]),
    handleUpdatePayment(val) {
      this.tableData = this.tableData.map(item => {
        if (item.bid_id === val.data.bid_id) {
          item = val.data
        }
      })
    },
    handleSelectAll() {
      if (this.multipleSelection.length > 0) {
        this.multipleSelection = []
      } else {
        this.multipleSelection = this.tableData
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    setDialogAddPayment(type) {
      this.visibleModalName = type
    },
    arraySpanMethod({ row, column, columnIndex }) {
      if (row.children) {
        return columnIndex === 1 ? [1, tableFields.length + 1] : [0, 0]
      }

      if (!singleColums.includes(column.property)) {
        const bid = this.tableData.find(res => res.bid_id === row.bid_id)
        const rowIndex = bid?.children.findIndex(ch => row.id === ch.id)

        return !bid ||
          rowIndex < 0 ||
          bid.children[rowIndex - 1]?.response_id === row.response_id
          ? [0, 1]
          : [this.checkChildren(bid.children, rowIndex, row.response_id), 1]
      }
    },
    checkChildren(items, index, response_id) {
      let k = index + 1
      let rows = 1

      for (; items[k]?.response_id === response_id; k++) {
        rows++
      }

      return rows
    },
    tableRowClassName({ row }) {
      return row.children ? 'group-title' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getContentTableCell(col, row) {
      return row.children ? row.name : this.getColumn(row, col.field)
    },
    getColumn(row, field) {
      return field === 'napravl'
        ? `${row[field].split(',')[1]}, ${row.cargo_receiver}`
        : row[field]
    },
    getClass(row) {
      let className = row['payments_left'] === 0 ? 'green' : 'red'

      if (row['payments_left'] < 0) {
        className = 'gold'
      }

      return className
    },
    async handleOpenModal(action, row) {
      if (['Ttn', 'Act', 'Passport', 'Driver', 'Payment'].includes(action)) {
        if (this.response.id !== row.response_id) {
          await this.fetchFlight({ id: row.response_id })
        }
        this.currentTtnId = row.id
        this[`isShow${action}Modal`] = true
      } else if (action === 'linkToDay') {
        const { bid_id: bidId, load_day_id: dayId } = row

        if (bidId && dayId) {
          window.open(
            `/bid/${bidId}/load-day/${dayId}?response_id=${row.response_id}`,
            '_blank',
          )
        }
      } else if (action === 'contragent') {
        if (this.innContagent !== row.inn) {
          this.innContagent = row.inn
        }
        this.isShowContragentModal = true
      } else if (action === 'Direction') {
        this.$alert(
          `${row.load_point} - ${row.napravl}. ${row.cargo_receiver}`,
          'Направление',
          {
            confirmButtonText: 'OK',
          },
        )
      }
    },
    handleUpdateAct() {
      this.handleUpdate()

      if (this.response?.id) {
        this.fetchFlightsActs(this.response.id)
      }
    },
    handleUpdate() {
      if (this.bid.id > 0) {
        this.fetchRegisterItem({ bid_id: this.bid.id })
      }
    },
    setClose(key = '') {
      if (key) {
        this[key] = false
      }
    },
    searchPayments(search) {
      this.search = { ...search }
      this.fetchItems()
    },
    changePage(page) {
      this.page = page
      this.fetchItems()
    },
    fetchItems() {
      this.fetchRegisterData({
        page: this.page,
        ...this.search,
      })
    },
    getTotalDebt() {
      totalDebtAPI
        .getTotalDebt()
        .then(result => (this.totalDebt = Number(result.data)))
    },
  },
}
</script>

<style lang="sass">
@import "~@/assets/styles/mixins.sass"

.register-of-payments
  font-size: 14px
  color: #000
  .btn-group
    display: flex
    align-items: center
  .toolbar
    margin-bottom: 20px
  .registry-table
    &.el-table
      border-bottom: 1px solid #000 !important
      border-right: 1px solid #000 !important
      border-top: 1px solid #000 !important
      overflow: visible
      min-height: auto
      .el-table__body-wrapper
        padding-bottom: 30px
      .el-table__body
        border-bottom: 1px solid #000 !important
      .el-table__placeholder, .el-table__indent
        display: none
      td, th
        padding: 0
        border-bottom: 1px solid #000 !important
        border-left: 1px solid #000 !important
      tr:last-of-type
        td
          border-bottom: none !important
      .cell
        font-size: 12px
        line-height: 1
        color: #000
        padding: 5px
        text-align: center
      td .cell
        white-space: nowrap
      .fs-10
        font-size: 10px
      .group-title .cell
        text-align: left
        font-weight: bold
        padding-left: 20px
        .el-table__expand-icon
          display: none
      .is-leaf .el-checkbox
        visibility: hidden
    .green
      color: #589839
    .red
      color: #ff0000
    .gold
      color: darkgoldenrod
  &__table-container
    padding: 0 40px
    +to(1510px)
      padding: 0 12px

  .pointer
    cursor: pointer

  .el-table__header-wrapper
    position: sticky
    top: 0
    z-index: 100

  .debitorka
    padding: 20px 12px 0
</style>
